import { render, staticRenderFns } from "./CreditForm.vue?vue&type=template&id=5c6404e6&scoped=true"
import script from "./CreditForm.vue?vue&type=script&lang=js"
export * from "./CreditForm.vue?vue&type=script&lang=js"
import style0 from "./CreditForm.vue?vue&type=style&index=0&id=5c6404e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6404e6",
  null
  
)

export default component.exports